export default __webpack_public_path__ + "static/media/f14b481c58fcab163c25a090c236ccfa.8a824153.svg";